import { GedCriteresFiltrageGedModelInput, PortailAlbumDto } from 'src/graphql/generated-types';

const stateName = '[WebAdministrationDocumentaryManagement] ';

export class WebAdministrationDocumentaryManagementInitRelatedListsAction {
    public static type = stateName + 'LoadRelatedLists';
}

export class WebAdministrationDocumentaryManagementSetFiltersAction {
    public static type = stateName + 'SetFilters';

    constructor(public filters: GedCriteresFiltrageGedModelInput) {}
}

export class WebAdministrationDocumentaryManagementToggleFiltersAction {
    static readonly type = stateName + 'ToggleFilters';

    constructor(public isFiltersOpened?: boolean) {}
}

export class WebAdministrationDocumentaryManagementReloadInitRelatedListsAction {
    static readonly type = stateName + 'ReloadInitRelatedLists';
}

export class ResetWebAdministrationDocumentaryManagementAction {
    public static type = stateName + 'ResetState';
}

export class WebAdministrationDocumentaryManagementSetSelectedRecordAction {
    public static type = stateName + 'SetSelectedRecord';

    constructor(public selectedRecord: PortailAlbumDto | null) {}
}
